<div class="mct-flex mct-row mct-justify-between mct-items-center">
  <h2>{{ 'form-builder.form-list.forms' | translate | titlecase }}</h2>
  <div>
    <action-button
      styleClass="atlas-btn atlas-btn-primary"
      [label]="'form-builder.form-list.create-a-new-form' | translate | uppercase"
      [items]="newFormActionItems"
    >
    </action-button>
  </div>
</div>

<div class="mv-27 mct-flex mct-row mct-justify-between mct-items-center">
  <div>
    {{ 'common.there-are' | translate | ucfirst }}
    <strong>{{ searchResult?.TotalCount ? searchResult.TotalCount : 0 }} {{ 'form-builder.form-list.forms' | translate }}</strong>
  </div>
  <div>
    <p-checkbox name="showInactive" [(ngModel)]="showInactive" [binary]="true" inputId="showInactive" (onChange)="search()"> </p-checkbox>
    <label for="showInactive">
      {{ 'form-builder.form-list.show-inactive' | translate | ucfirst }}
    </label>
  </div>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [lazy]="true"
    [loading]="loading"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Title">
          {{ 'form-builder.form-list.form-name' | translate | ucfirst }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th pSortableColumn="SubmissionCount">
          {{ 'form-builder.form-list.submissions' | translate | ucfirst }}
          <p-sortIcon field="SubmissionCount"></p-sortIcon>
        </th>
        <th pSortableColumn="FormType">
          {{ 'form-builder.form-list.form-type' | translate | ucfirst }}
          <p-sortIcon field="FormType"></p-sortIcon>
        </th>
        <th pSortableColumn="Id">
          {{ 'form-builder.form-list.form-id' | translate }}
          <p-sortIcon field="Id"></p-sortIcon>
        </th>
        <th pSortableColumn="Inactive" *ngIf="showInactive">
          {{ 'form-builder.form-list.form-status' | translate | ucfirst }}
          <p-sortIcon field="Inactive"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-formTemplate>
      <tr>
        <td>
          <a [routerLink]="getEditLink(formTemplate.FormType, formTemplate.Id)">{{ formTemplate.Title }}</a>
        </td>
        <td>
          <a [routerLink]="['/form-builder/form', formTemplate.Id, 'submissions']">{{ formTemplate.SubmissionCount }}</a>
        </td>
        <td>{{ getFormTypeDisplayName(formTemplate.FormType) }}</td>
        <td data-cy="tdFormId">{{ formTemplate.Id }}</td>
        <td *ngIf="showInactive">
          {{ (formTemplate.Inactive ? 'form-builder.form-list.inactive' : 'form-builder.form-list.active') | translate | ucfirst }}
        </td>
        <td>
          <action-button
            *ngIf="rowMenuItems[formTemplate.Id]?.length"
            styleClass="atlas-btn atlas-btn-primary"
            [label]="'common.actions' | translate | uppercase"
            [items]="rowMenuItems[formTemplate.Id]"
          >
          </action-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <wl-page-size-dropdown
    class="mt-5"
    [(pageSize)]="searchParams.PageSize"
    [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"
  ></wl-page-size-dropdown>
</div>

<p-confirmDialog
  #cd
  key="deleteFormTemplate"
  header="{{ 'form-builder.form-list.confirm-delete' | translate | ucfirst }}"
  icon="pi pi-exclamation-triangle"
>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="cd.onReject()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn btn-primary" (click)="cd.onAccept()">
      {{ 'common.delete' | translate | uppercase }}
    </button>
  </ng-template>
</p-confirmDialog>
